import { useState } from 'react';
import { buildReschedulePatch, isRescheduleReasonValid } from './utils';

// Reschedule-reason state shared by the reschedule modals.
export default function useRescheduleReason() {
    const [reason, setReason] = useState('');
    const [notes, setNotes] = useState('');

    return {
        reason,
        notes,
        reset: () => {
            setReason('');
            setNotes('');
        },
        isValid: isRescheduleReasonValid({ reason, notes }),
        patch: buildReschedulePatch({ reason, notes }),
        fieldProps: { reason, notes, onChangeReason: setReason, onChangeNotes: setNotes },
    };
}
